module.exports = __webpack_public_path__ + "static/Outfit-Regular-1e83c7fb45c757632cd6017b69535e01.woff2";